import { ItemDePedidoConsultaDTO } from '../../../models/pedidos/pedido.model';
import { EstadoDePedido } from '../../../enums/EstadoDePedido.enum';

// =============================================================================
// Motivo de a linha do item estar esgotada (saldo 0): faturada ou cancelada.
// A UI traduz o motivo em cor (verde x vermelho) no dialogo de detalhe e no
// card da listagem — a regra mora aqui para as duas telas nunca divergirem.
// Linha MISTA (parte faturada, parte cancelada) conta como faturada: existe
// nota emitida para ela.
// =============================================================================

/** Linha esgotada cuja quantidade TODA foi cancelada. */
export function itemFoiCancelado(item: ItemDePedidoConsultaDTO): boolean {
  return item.saldo === 0 && (item.quantidadeCancelada || 0) >= item.quantidade;
}

/** Linha esgotada com algum faturamento (mista conta como faturada). */
export function itemFoiFaturado(item: ItemDePedidoConsultaDTO): boolean {
  return item.saldo === 0
    && !itemFoiCancelado(item)
    && (item.quantidadeFaturada || 0) > 0;
}

/**
 * Pedido encerrado = FINALIZADO ou CANCELADO: nenhuma linha segue ativa.
 *
 * O esmaecimento das linhas liquidadas existe para contrasta-las com as ainda
 * abertas; num pedido encerrado nao ha linha aberta, entao ele e desligado e
 * fica so o tint (que diz o motivo, nao o andamento).
 *
 * Recebe o estado JA RESOLVIDO (cada componente tem `resolveEstado` proprio).
 */
export function pedidoEstaEncerrado(estado: EstadoDePedido | null | undefined): boolean {
  return estado === EstadoDePedido.FINALIZADO || estado === EstadoDePedido.CANCELADO;
}
